import React, { Component } from 'react'
import './styles/TextLookup.css'

class TextLookup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: ''
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleChange(event) {
    this.setState({
      value: event.target.value
    })
  }

  handleSubmit(event) {
    if(this.props.onSubmit) {
      this.props.onSubmit(this.state.value)
    }
    event.preventDefault()
  }

  render() {
    return (
      <div className="textLookup">
        <form
          onSubmit={this.handleSubmit}
        >
          <input
            type="text" placeholder={this.props.placeholder}
            value={this.state.value}
            onChange={this.handleChange}
          />
          <input type="submit" value="Search" />
        </form>
      </div>
    )
  }
}

export default TextLookup



// WEBPACK FOOTER //
// ./src/components/TextLookup.js